<template>
  <div id="app">
    <Navbar />
    <Hero />
    <Features />
    <Services />
    <About />
    <Contact />
    <Footer />
  </div>
</template>

<script>
  import Navbar from './components/Navbar.vue'
  import Hero from './components/Hero.vue'
  import Features from './components/Features.vue'
  import Services from './components/Services.vue'
  import About from './components/About.vue'
  import Contact from './components/Contact.vue'
  import Footer from './components/Footer.vue'

  export default {
    name: 'App',
    components: {
      Navbar,
      Hero,
      Features,
      Services,
      About,
      Contact,
      Footer
    }
  }
</script>

<style>
  /* 全局样式会继承自Tailwind配置 */

</style>
